import React, {useContext, useEffect} from 'react';
import {MyContext} from "./MyContext";
import NewTabulator from "../../NewTabulator/NewTabulator";
import {formatToPersianAddCommaNegativeToParentheses} from "../../../utils/CommaSeparator";
import {sum1, sum1And2, sum2, sum3, sumFinalRemainSum} from "./functions"

function TableShow() {

  const value = useContext(MyContext);
  console.log(value)
  const setData = value.setData
  const data = value.data.mainData?.data;

  data?.column.map(col => {

    col.formatter = (cell) => {
      try {
        const temp = formatToPersianAddCommaNegativeToParentheses(cell.getValue())
        return <>{temp}</>
      } catch (error) {
        return <>{error.toString()}</>
      }

    }
    if (data.priceFields.includes(col.field)) {
      col.bottomCalc = "sum";
    }
  })

  useEffect(() => {
    const mySum = {
      remainSum1: NaN,
      totalRemainingSum1: NaN,
      remainSum2: NaN,
      totalRemainingSum2: NaN,
      remainSumTable1And2: NaN,
      totalRemainingRemainSumTable1And2: NaN,
      remainSumTable3: NaN,
      totalRemainingRemainSumTable3: NaN,
      finalRemainSum: NaN,
      finalTotalSum: NaN,
    }
    mySum.remainSum1 = sum1(data, "remaining")
    mySum.totalRemainingSum1 = sum1(data, "totalRemaining")

    mySum.remainSum2 = sum2(data, "remaining")
    mySum.totalRemainingSum2 = sum2(data, "totalRemaining")

    mySum.remainSumTable1And2 = sum1And2(data, "remaining")
    mySum.totalRemainingRemainSumTable1And2 = sum1And2(data, "totalRemaining")

    mySum.remainSumTable3 = sum3(data, "remaining")
    mySum.totalRemainingRemainSumTable3 = sum3(data, "totalRemaining")

    mySum.finalRemainSum = sumFinalRemainSum(data, "remaining"); // 1and2 - 3
    mySum.finalTotalSum = sumFinalRemainSum(data, "totalRemaining");

    setData({mySum})


  }, [data]);
  const mySum = value.data.mySum

  try {
    return (
      <div>
        <div style={{maxWidth: 600}}>
          <div className={"part_1"}>
            <div className={"text-center title__costBenefit2"}> {data?.part_1?.caption}</div>
            <NewTabulator
              columns={data?.column}
              data={data?.part_1?.data}
              className={"header__costBenefit2__table "}

            />
          </div>

          <div className={"part_1"}>
            <div className={"text-center title__costBenefit2"}> {data?.part_2?.caption}</div>
            <NewTabulator
              columns={data?.column}
              data={data?.part_2?.data}
              className={"header__costBenefit2__table "}

            />``
          </div>

          <div className={"part_2"}>
            <div className={"text-center title__costBenefit2"}> {data?.part_3?.caption}</div>
            <NewTabulator
              columns={data?.column}
              data={data?.part_3?.data}
              className={"header__costBenefit2__table "}

            />
            <ul className={"d-flex justify-content-center"}>
              <li className={"w-100 bg-danger0"}>سود/زیان ناخالص</li>
              {!isNaN(mySum.remainSumTable1And2) && <li
                className={"w-100 bg-danger0"}>{formatToPersianAddCommaNegativeToParentheses(mySum?.remainSumTable1And2)}</li>}
              {!isNaN(mySum?.totalRemainingRemainSumTable1And2) && <li
                className={"w-100 text-bg-info0"}>{formatToPersianAddCommaNegativeToParentheses(mySum?.totalRemainingRemainSumTable1And2)}</li>}
            </ul>
          </div>

          <div className={"part_3"}>
            <div className={"text-center title__costBenefit2"}> {data?.part_4?.caption}</div>
            <NewTabulator
              columns={data?.column}
              data={data?.part_4?.data}
              className={"header__costBenefit2__table "}
            />
            <hr/>
            <div className={"w-100 px-0"}>
              <ul className={"w-100 d-flex justify-content-center px-0"}>
                <li className={"w-100"}></li>
                <li className={"w-100"}>سود/زیان ناخالص</li>
                {!isNaN(mySum?.remainSumTable1And2) && <li
                  className={"w-100 text-bg-info0"}>{formatToPersianAddCommaNegativeToParentheses(mySum?.remainSumTable1And2)}</li>}

                {!isNaN(mySum.totalRemainingRemainSumTable1And2) && <li
                  className={"w-100 text-bg-info0"}>{formatToPersianAddCommaNegativeToParentheses(mySum.totalRemainingRemainSumTable1And2)}</li>}
              </ul>
              <ul className={"w-100 d-flex justify-content-center px-0"}>

                <li className={"w-100 text-info fw-bold"}>کسر می شود</li>
                <li className={"w-100 "}>سایر هزینه ها</li>

                {!isNaN(mySum?.remainSumTable3) && <li
                  className={"w-100 "}>{formatToPersianAddCommaNegativeToParentheses(mySum.remainSumTable3)}</li>}
                {!isNaN(mySum?.totalRemainingRemainSumTable3) && <li
                  className={"w-100 "}>{formatToPersianAddCommaNegativeToParentheses(mySum?.totalRemainingRemainSumTable3)}</li>}
              </ul>
            </div>
            <hr/>
            <ul className={"w-100 d-flex justify-content-center px-0"}>
              <li className={"w-100"}></li>
              <li className={"w-100 "}>سود و زیان خالص</li>

              {!isNaN(mySum?.finalRemainSum) &&
                <li className={"w-100 "}>{formatToPersianAddCommaNegativeToParentheses(mySum.finalRemainSum)}</li>}
              {!isNaN(mySum?.finalTotalSum) && <li
                className={"w-100 "}>{formatToPersianAddCommaNegativeToParentheses(mySum?.finalTotalSum)}
              </li>}
            </ul>
          </div>
        </div>
      </div>);
  } catch (error) {
    return <>{error.toString()}</>
  }
}

export default TableShow;